import { discardProgramWorkspaceScopesForAnnualTimetableChange } from './programEditWorkspace';
import { postCrossTabSaveSignal, subscribeCrossTabSaveSignal } from './crossTabSaveSignal';

export const ANNUAL_TIMETABLE_SAVED_EVENT = 'cp:annual-timetable-saved';

export type AnnualTimetableSavedDetail = {
  workspaceId: string;
  academicYear: number;
  termNumbers: Array<1 | 2>;
  gradeIds: string[];
  /** 다른 탭에서 온 신호(편집본 정리·재전송 생략) */
  remote?: boolean;
};

export function emitAnnualTimetableSaved(detail: AnnualTimetableSavedDetail): void {
  if (typeof window === 'undefined') return;
  if (!detail.workspaceId) return;
  if (!detail.remote) discardProgramWorkspaceScopesForAnnualTimetableChange(detail);
  window.dispatchEvent(new CustomEvent(ANNUAL_TIMETABLE_SAVED_EVENT, { detail }));
  if (!detail.remote) postCrossTabSaveSignal('annual-timetable-saved', detail);
}

subscribeCrossTabSaveSignal('annual-timetable-saved', (raw) => {
  const d = raw as Partial<AnnualTimetableSavedDetail>;
  if (!d.workspaceId || typeof d.academicYear !== 'number') return;
  emitAnnualTimetableSaved({
    workspaceId: d.workspaceId,
    academicYear: d.academicYear,
    termNumbers: Array.isArray(d.termNumbers) ? d.termNumbers.filter((t): t is 1 | 2 => t === 1 || t === 2) : [],
    gradeIds: Array.isArray(d.gradeIds) ? d.gradeIds.filter((g): g is string => typeof g === 'string') : [],
    remote: true,
  });
});
